import _ from "lodash";
import React from "react";
import classes from "./CreatePost.scss";
import update from "immutability-helper";
import classNames from "classnames";
import {
  AddAttachment,
  AddPostDetails,
  TagStudents,
  SharedWith,
  TagFolders,
  TagPracticesV2,
  VoiceRecorder,
  CaptureVideo,
  CaptureImage,
  ReorderImages,
  ManageSubjectJournalPost,
  ManageStudentActivity,
  SelectDateTime,
  TagResourceV2,
  TagUnitV2,
  TagUnitV3,
  TagPost,
  TagLearningGoals,
  TagResourceV3,
  TagPostV2,
} from "./components/Screens";
import ToddleDoc from "AppComponents/ToddleDoc";
import { connect } from "react-redux";
import { graphql, compose } from "lib/apolloClient";
import { getIsAdminByRole } from "lib/staffPermissionUtils";
import {
  updatePost,
  resetPost,
  updateOrEditPost,
  updateFolderArray,
  updateFolderInArrayByName,
  createMedia,
  updateAssignmentToJournal,
  updateStudentListFilters,
  ACTIVITY_FOOD,
  ACTIVITY_NAP,
  ACTIVITY_TOILET,
  STEP_BY_ACTIVITY_TYPE,
  createAttachmentGroups,
} from "Post/modules/PostModule";
import { addBulkWorksheetResponseToPortfolio } from "Worksheet/modules/WorksheetModules";
import DialogueBoxV2 from "UIComponents/DialogueBoxV2";
import withLoader from "UIComponents/GqlWithLoader";
import I18nHOC from "UIComponents/I18nHOC";
import FullScreenLoader from "UIComponents/FullScreenLoader";
import UIModal from "UIComponents/UIModal";
import DialogueBoxV3 from "UIComponents/DialogueBoxV3";
import { setToastMsg } from "Login/modules/LoginModule/LoginActions";
import {
  getPostDetailQuery,
  getPlatformUserDetailsQuery,
} from "Post/modules/PostQuery";
import { getUserBasicDetailsFromCache } from "modules/CommonGraphqlHelpers";

import { getCourseDetailsFromCache } from "Course/modules/CourseGraphqlHelpers";
import { getStudentAssignmentDetailsFromCache } from "ClassRoom/modules/ClassRoomGraphqlHelpers";
import { getFormattedUserName } from "Utils/GetFormattedUserName";
import Workbook from "AppComponents/Workbook";
import { getAttachment, deleteAttachmentGroups } from "modules/Services";
import { getPrintFile } from "modules/PrintThunks";
import {
  WORKBOOK_MODE_TYPES,
  getAttachmentsByTypeFromAttachmentArr,
  isTabletByUserAgent,
} from "Utils";

import getEvaluationCyclesGraphql from "SnP_v2/modules/EnhanceQueries/getEvaluationCyclesGraphql";
import {
  SNPv2_ACCESS_PERMISSION,
  ENABLE_AUTH_AND_EVAL_REVAMP,
} from "Constants/permissionConstants";
import { editStudentAssignmentSubmission } from "ClassRoom/modules/ClassRoomModule";

import {
  hasTranslationPermission,
  getPostTranslationFilter,
  getFormattedStudentActivityData,
  isPortFolioManagerEnabled,
  isPortfolioParityEnabled,
  isPortfolioParityEnabledAndIsJournalRoute,
  isPortfolioReviewSetupEnabled,
  isPortfolioReviewSetupEnabledAndIsJournalRoute,
  getIsNewGoalTaggingEnabled,
  isAssessmentTagged,
  isUnitPlanTagged,
} from "Post/utils";
import {
  isDPSubjectJournalEnabled,
  showActivityTracking,
} from "AppComponents/Post/utils";
import { getSettingValue } from "modules/PermissionModule";
import { hasIncludeGivenPathInCurrentRoute } from "Teacher/routes/Courses/routes/Course/routes/UnitPlans/routes/UnitPlanDetails/routes/EditUnitPlan/routes/IBPlanner/modules/IBPlannerModule";
import {
  CURRICULUM_TYPE_MYP,
  CURRICULUM_TYPE_PYP,
  CURRICULUM_TYPE_UBD,
  CURRICULUM_TYPE_DP,
} from "Constants/stringConstants";
import {
  getSelectedAcademicYearId,
  getSelectedCurriculumId,
} from "modules/CommonSelectors";
import ACLStore from "lib/aclStore";
import ACLStorage from "lib/aclService";

import { getPlatformUserDetailsFromCache } from "Post/modules/PostGraphqlHelpers";
import { getSelectedLearningCourseId } from "Teacher/routes/LearningCourse/modules/Utils";
import { getIsLearningCoursesEnabled } from "Teacher/routes/LearningCourses/modules/Utils";

const BLANK_OBJECT = {};
const DIALOGS_INFO = {
  DISCARD: {
    title: "journal:discard_dialog_title",
    documentDiscardTitle: "classRoom:discard_document",
    documentDiscardMessage: "classRoom:discard_document_message",
    message: "journal:discard_dialog_message",
    confirmButtonText: "common:continue_editing_agree",
    cancelButtonText: "common:discard",
    button1CancelProps: isPortfolioParityEnabled => ({
      variant: "destructive",
      size: isPortfolioParityEnabled ? "medium" : "large",
      testId: "journal-postcreation-disard-warning-dialog-discard",
    }),
    button2ConfirmProps: isPortfolioParityEnabled => ({
      variant: isPortfolioParityEnabled ? "neutral" : "progressive",
      type: isPortfolioParityEnabled ? "outlined" : "fill",
      size: isPortfolioParityEnabled ? "medium" : "large",
      testId: "journal-postcreation-disard-warning-dialog-continue",
    }),
  },
};

const AddAttachmentsScreens = [
  "STUDENT_ASSIGNMENT_SUBMISSION",
  "STUDENT_GOAL",
  "STUDENT_GOAL_TASK",
];
const STEP_DETAILS = {
  CREATE_POST: [
    {
      title: "create_post",
      containerStyle: { maxWidth: 900, padding: "32px 40px 0" },
      screen: props =>
        (_.includes(AddAttachmentsScreens, _.get(props, "parentType")) &&
          !_.get(props, "isAddLEToJournal")) ||
        (_.get(props, "portfolioType") === "junior" &&
          isPortfolioParityEnabled()) ||
        !isPortfolioParityEnabled() ? (
          <AddAttachment
            screenPanelProps={props}
            showDesignV2={isPortfolioParityEnabled()}
          />
        ) : (
          <ManageSubjectJournalPost
            screenPanelProps={props}
            isJuniorFolio={true}
          />
        ),
    },
  ],
  CAPTURE_VIDEO: [
    {
      title: "",
      screen: props => (
        <CaptureVideo
          screenPanelProps={props}
          showDesignV2={isPortfolioParityEnabled()}
        />
      ),
    },
  ],
  REORDER_IMAGES: [
    {
      title: "",
      containerStyle: { maxWidth: 800 },
      screen: props => <ReorderImages screenPanelProps={props} />,
    },
  ],
  CAPTURE_IMAGE: [
    {
      title: "",
      screen: props => (
        <CaptureImage
          screenPanelProps={props}
          showDesignV2={isPortfolioParityEnabled()}
        />
      ),
    },
  ],
  POST_DETAIL: [
    {
      title: "",
      containerStyle: { maxWidth: 658, padding: "32px 0" },
      showPreview: false,
      screen: props =>
        isPortfolioParityEnabled() ? (
          // &&  hasIncludeGivenPathInCurrentRoute({ path: "/journal" })
          <ManageSubjectJournalPost
            screenPanelProps={props}
            isJuniorFolio={true}
          />
        ) : (
          <AddPostDetails screenPanelProps={props} />
        ),
    },
  ],
  EDIT_POST: [
    {
      title: "edit_post",
      showPreview: false,
      containerStyle: { maxWidth: 658, padding: "32px 0" },
      screen: props =>
        isPortfolioParityEnabled() ? (
          <ManageSubjectJournalPost
            screenPanelProps={props}
            isJuniorFolio={true}
          />
        ) : (
          <AddPostDetails screenPanelProps={props} />
        ),
    },
  ],
  TAG_STUDENT: [
    {
      title: "tag_students",
      screen: props => <TagStudents screenPanelProps={props} />,
    },
  ],

  TAG_SINGLE_STUDENT: [
    {
      title: "tag_students",
      screen: props => (
        <TagStudents
          screenPanelProps={props}
          studentSelectionMode={"MULTIPLE"}
          showNewDesign={isPortfolioParityEnabled()}
        />
      ),
    },
  ],
  // OLD FLOW, 3 step process
  TAG_PYP_ELEMENT: [
    {
      title: "tag_pyp_elements",
      screen: props =>
        isPortfolioParityEnabled() ? (
          <TagUnitV3 screenPanelProps={props} />
        ) : (
          <TagUnitV2 screenPanelProps={props} />
        ),
    },
    {
      title: "select_learning_goals_from_unit",
      screen: props =>
        isPortfolioParityEnabled() ? (
          <TagResourceV3 screenPanelProps={props} />
        ) : (
          <TagResourceV2 screenPanelProps={props} />
        ),
    },
    {
      title: "tag_PYP_elements_stage",
      screen: props => <TagLearningGoals props={props} />,
    },
  ],
  // -- following 3 properties, are new FLOW where selection efforts are reduced.
  TAG_FROM_ALL_LEARNING_GOALS: [
    {
      title: "tag_from_all_learning_goals",
      screen: props => <TagLearningGoals props={props} />,
    },
  ],
  TAG_LEARNING_GOALS_FROM_UNIT: [
    {
      title: "select_unit",
      screen: props =>
        isPortfolioParityEnabled() ? (
          <TagUnitV3 screenPanelProps={props} />
        ) : (
          <TagUnitV2 screenPanelProps={props} />
        ),
    },
    {
      title: "tag_learning_goals_from_unit",
      screen: props => <TagLearningGoals props={props} />,
    },
  ],
  TAG_LEARNING_GOALS_FROM_POST: [
    {
      title: "select_post",
      screen: props =>
        isPortfolioParityEnabled() ? (
          <TagPostV2 screenPanelProps={props} />
        ) : (
          <TagPost screenPanelProps={props} />
        ),
    },
    {
      title: "select_post",
      screen: props => <TagLearningGoals props={props} />,
    },
  ],
  TAG_LEARNING_GOALS_FROM_ASSESSMENTS: [
    {
      title: "tag_learning_goals_from_le",
      screen: props =>
        isPortfolioParityEnabled() ? (
          <TagResourceV3 screenPanelProps={props} />
        ) : (
          <TagResourceV2 screenPanelProps={props} />
        ),
    },
    {
      title: "tag_learning_goals_from_le",
      screen: props => <TagLearningGoals props={props} />,
    },
  ],
  SHARE_WITH: [
    {
      title: "common:share_with",
      screen: props => <SharedWith screenPanelProps={props} />,
    },
  ],
  TAG_FOLDERS: [
    {
      title: "tag_folders",
      screen: props => <TagFolders screenPanelProps={props} />,
    },
  ],
  TAG_PRACTICES_V2: [
    {
      title: "tag_practices",
      screen: props => (
        <TagPracticesV2 screenPanelProps={props}></TagPracticesV2>
      ),
    },
  ],
  VOICE_RECORDER: [
    {
      title: "",
      screen: props => <VoiceRecorder screenPanelProps={props} />,
    },
  ],
  // Following Step will show screen for DP subject journal post creation
  MANAGE_SUBJECT_JOURNAL_POST_DETAILS: [
    {
      title: "create_post",
      screen: props =>
        _.get(props, "portfolioType") === "junior" &&
        isPortfolioParityEnabled() &&
        _.isEqual(props?.mode, "create") &&
        !(
          _.get(props, "isAddStudentAttachmentToJournal") ||
          _.get(props, "isAddLEToJournal") ||
          _.get(props, "isAddAllResponsesToJournal")
        ) ? (
          <AddAttachment
            screenPanelProps={props}
            showDesignV2={isPortfolioParityEnabled()}
          />
        ) : (
          <ManageSubjectJournalPost screenPanelProps={props} />
        ),
    },
  ],
  MANAGE_FOOD_ACTIVITY: [
    {
      title: "create_post",
      screen: props => (
        <ManageStudentActivity
          activityType={ACTIVITY_FOOD}
          screenPanelProps={props}
        />
      ),
    },
  ],
  MANAGE_NAP_ACTIVITY: [
    {
      title: "create_post",
      screen: props => (
        <ManageStudentActivity
          activityType={ACTIVITY_NAP}
          screenPanelProps={props}
        />
      ),
    },
  ],
  MANAGE_TOILET_ACTIVITY: [
    {
      title: "create_post",
      screen: props => (
        <ManageStudentActivity
          activityType={ACTIVITY_TOILET}
          screenPanelProps={props}
        />
      ),
    },
  ],
  SELECT_DATE_TIME: [
    {
      title: "select_date_and_time",
      screen: props => <SelectDateTime screenPanelProps={props} />,
    },
  ],
};

const getElementNodes = containerRef => {
  return Array.from(containerRef.querySelectorAll('a, button, [tabindex="0"]'));
};
class CreatePost extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      currentStep: "CREATE_POST",
      stepCurrentIndexes: {},
      stepList: [],

      currentDialogAction: "",

      isReorderEdit: false,
      isFullScreenLoading: false,
      workbookMode: null,
      showToddleDoc: false,
      createdToddleDoc: null,
    };
    this.containerRef = React.createRef();
  }

  isSnpV2Enabled = ACLStorage.getModuleSettingsValue(SNPv2_ACCESS_PERMISSION);

  UNSAFE_componentWillMount = () => {
    const {
      resetPost,
      mode,
      updatePost,
      currentStep,
      currentStepIndex = 0,
      isInnerModal,
      postEditDetail,
      setToastMsg,
      userInfo: { id: userId, userEntityType, user_type: userType },
      postCreateDetail,
      curriculumProgramId,
    } = this.props;

    //Handled if post is deleted

    if (_.get(postEditDetail, "isDeleted", false)) {
      this.onCloseClick();
      setToastMsg("toastMsgs:trying_to_access_deleted_post");
    } else {
      const updatedCurrentStep = currentStep
        ? currentStep
        : mode == "edit"
        ? "EDIT_POST"
        : "CREATE_POST";

      if (currentStepIndex == 0) this.goToStep(updatedCurrentStep);
      else {
        if (isInnerModal) {
          this.goToPage(updatedCurrentStep, currentStepIndex);
        }
      }
      if (!isInnerModal) {
        resetPost();

        this.setPostDetailsInStore();

        // Set student user by default tagged when creates a post
        if (mode == "create") {
          if (userType == "student") {
            updatePost({
              curriculumProgramId,
              students: {
                edges: [
                  {
                    node: getUserBasicDetailsFromCache({
                      id: userId,
                      type: userEntityType,
                    }),
                    __typename: "StudentsEdge",
                  },
                ],
              },
            });
          } else {
            updatePost({ curriculumProgramId });
          }
        }
        const postTaggedEntity = [
          ...(!_.isEmpty(_.get(postCreateDetail, "resourceItem"))
            ? [
                {
                  entityType: _.get(
                    postCreateDetail,
                    "resourceType",
                    "ASSESSMENT"
                  ),
                  entity: _.get(postCreateDetail, "resourceItem", {}),
                  id: _.get(postCreateDetail, "resourceItem.id", ""),
                },
              ]
            : []),
          ...(!_.isEmpty(_.get(postCreateDetail, "unitPlan"))
            ? [
                {
                  entityType: "UNIT_PLAN",
                  entity: _.get(postCreateDetail, "unitPlan", {}),
                  id: _.get(postCreateDetail, "unitPlan.id", ""),
                },
              ]
            : []),
        ];
        if (postCreateDetail) {
          updatePost({
            ...(postCreateDetail || BLANK_OBJECT),
            curriculumProgramId,
            ...(_.get(postCreateDetail, "isShareEvaluation") ||
            (getIsNewGoalTaggingEnabled() && !_.isEmpty(postTaggedEntity))
              ? { postTaggedEntity }
              : {}),
          }); // set post create detail in redux if passed from parent component
        }
      }
    }
  };

  handleKeyDown = event => {
    const { key } = event;
    const { currentStep } = this.state;
    const elementNodes = getElementNodes(this.containerRef?.current);
    const filteredElements = _.filter(
      elementNodes,
      node => !_.includes(node.id, "dropdown-item")
    );
    const currentIndex = filteredElements.indexOf(document.activeElement);
    if (key === "Tab") {
      if (
        (!elementNodes.includes(document.activeElement)
          ? document.activeElement !== this.containerRef?.current
          : !elementNodes.includes(document.activeElement)) &&
        currentStep === "CREATE_POST" &&
        !_.includes(document.activeElement.id, "dropdown-item") &&
        document.activeElement.tagName !== "INPUT"
      ) {
        this.stopPropagationAndPreventDefault(event);
        _.first(elementNodes).focus();
      }
      if (
        elementNodes.indexOf(document.activeElement) ===
        elementNodes.length - 1
      ) {
        this.stopPropagationAndPreventDefault(event);
        _.first(elementNodes).focus();
      }
    } else if (
      (key === "ArrowRight" || key === "d") &&
      elementNodes.includes(document.activeElement)
    ) {
      this.stopPropagationAndPreventDefault(event);
      if (currentIndex < filteredElements.length - 1) {
        filteredElements[currentIndex + 1]?.focus();
      } else {
        _.first(filteredElements)?.focus();
      }
    } else if (
      (key === "ArrowLeft" || key === "a") &&
      elementNodes.includes(document.activeElement)
    ) {
      this.stopPropagationAndPreventDefault(event);
      if (currentIndex > 0) {
        filteredElements[currentIndex - 1].focus();
      } else {
        _.last(filteredElements).focus();
      }
    } else if (key === "ArrowDown") {
      this.stopPropagationAndPreventDefault(event);
      const currentIndex = elementNodes.indexOf(document.activeElement);
      if (currentIndex < elementNodes.length - 1) {
        elementNodes[currentIndex + 1].focus();
      } else {
        _.first(elementNodes).focus();
      }
    } else if (key === "ArrowUp") {
      this.stopPropagationAndPreventDefault(event);
      const currentIndex = elementNodes.indexOf(document.activeElement);
      if (currentIndex > 0) {
        elementNodes[currentIndex - 1].focus();
      } else {
        _.last(elementNodes).focus();
      }
    }
  };

  componentDidMount = () => {
    const { currentStep } = this.state;
    const { postCreateDetail, parentId, parentType } = this.props;

    if (
      this.containerRef &&
      (currentStep === "CREATE_POST" || currentStep === "EDIT_POST")
    ) {
      // traping focus logic
      const focusableElements = Array.from(
        this.containerRef.current?.querySelectorAll(
          'a, button, [tabindex="0"]'
        ) || []
      );
      this.focusableElements = focusableElements;

      if (document.activeElement !== this.containerRef) {
        setTimeout(() => this.containerRef.current?.focus(), 300);
      }
      this.containerRef.current?.addEventListener(
        "keydown",
        this.handleKeyDown
      );
    } else {
      this.containerRef.current?.removeEventListener(
        "keydown",
        this.handleKeyDown
      );
    }

    const isAddAllResponsesToJournal = _.get(
      postCreateDetail,
      "isAddAllResponsesToJournal"
    );
    if (
      !isAddAllResponsesToJournal &&
      _.get(postCreateDetail, "canAddWorksheetResponseToPost", false)
    ) {
      // Generate response pdf and add it to post attachments
      this.generateWorksheetResponsePdf();
    }

    window.history.pushState(null, "", window.location.pathname);

    this.handlePopState = this.handlePopState.bind(this);
    window.addEventListener("popstate", this.handlePopState);
  };

  handlePopState(event) {
    window.history.pushState(null, "", window.location.pathname);
    this.onCloseClick();
  }

  componentDidUpdate = (prevProps, prevState) => {
    const {
      postEditDetail,
      setToastMsg,
      isInnerModal,
      updatePost,
    } = this.props;
    const { currentStep } = this.state;
    const isDeleted = _.get(postEditDetail, "isDeleted", false);

    //Handled if post is deleted and data is already in cache
    if (
      _.get(prevProps, "postEditDetail.isDeleted", false) != isDeleted &&
      isDeleted
    ) {
      this.onCloseClick();
      setToastMsg("toastMsgs:trying_to_access_deleted_post");
    }
    if (prevProps.isLoading != this.props.isLoading && !isInnerModal) {
      this.setPostDetailsInStore();
    }

    if (
      currentStep === "CREATE_POST" &&
      prevState.currentStep !== "CREATE_POST"
    ) {
      updatePost({ attachments: [] });
    }
    if (
      currentStep !== prevState.currentStep ||
      currentStep === "EDIT_POST" ||
      currentStep === "CREATE_POST"
    ) {
      if (this.containerRef) {
        const focusableElements = Array.from(
          this.containerRef.current?.querySelectorAll(
            'a, button, [tabindex="0"]'
          ) || []
        );
        this.focusableElements = focusableElements;

        // if (document.activeElement !== this.containerRef) {
        //   setTimeout(() => this.containerRef.current?.focus(), 300);
        // }
        this.containerRef.current?.addEventListener(
          "keydown",
          this.handleKeyDown
        );
      }
    }
  };

  stopPropagationAndPreventDefault = event => {
    event.preventDefault();
    event.stopPropagation();
  };

  componentWillUnmount = () => {
    const { updateStudentListFilters, resetPost } = this.props;
    const { currentStep } = this.state;
    updateStudentListFilters({ searchText: "" });
    if (
      hasIncludeGivenPathInCurrentRoute({ path: "/portfolio-review" }) &&
      isPortfolioReviewSetupEnabled()
    ) {
      _.isEqual(currentStep, "EDIT_POST") && resetPost();
    }
    if (this.containerRef) {
      this.containerRef.current?.removeEventListener(
        "keydown",
        this.handleKeyDown
      );
    }
    window.removeEventListener("popstate", this.handlePopState);
  };

  generateWorksheetResponsePdf = async () => {
    const { postCreateDetail, getPrintFile, t } = this.props;

    this.setState({ isFullScreenLoading: true });

    try {
      const studentAssignmentId = _.get(
        postCreateDetail,
        "studentAssignmentId",
        null
      );

      const responsePdfUrl = await getPrintFile({
        id: studentAssignmentId,
        type: "worksheetResponse",
        shouldOpenInWindow: false,
      });

      // Get student details from cache to use student name
      let studentName;
      const studentAssignmentData = getStudentAssignmentDetailsFromCache({
        id: studentAssignmentId,
        showOnlySubmitted: false,
        userFilter: "ALL",
        entityEventsFilter: {
          orderBy: "EVENT_TIME",
          orderByDir: "ASC",
        },
      });
      const student = _.get(studentAssignmentData, "student", {});
      if (!_.isEmpty(student)) {
        studentName = getFormattedUserName({ user: student });
      }

      const attachment = {
        type: "FILE",
        name: `${t("common:response_with_name", {
          name: studentName,
        })}_${studentAssignmentId}`,
        mimeType: "application/pdf",
        url: responsePdfUrl,
        metadata: {
          isWorksheetResponse: true, // Adding identifier for worksheet responses
        },
      };

      this.addPostAttachment(attachment);
      // add responsePdfUrl to post attachments
    } finally {
      this.setState({ isFullScreenLoading: false });
    }
  };

  addPostAttachment = attachment => {
    const {
      updatePost,
      postDetails: { attachments = [] },
    } = this.props;

    updatePost({
      attachments: [
        _.omit(attachment, [
          "streamUrl",
          "signedUrl",
          "__typename",
          "isPost",
          "isRead",
          "questionAttachment",
        ]),
        ...attachments,
      ],
    });
  };

  updatePostAttachments = newAttachment => {
    const {
      updatePost,
      postDetails: { attachments = [] },
    } = this.props;
    const filteredAttachments = _.filter(
      attachments,
      attachment =>
        _.get(attachment, "id", "") !== _.get(newAttachment, "id", "")
    );
    const newAttachments = [
      _.omit(newAttachment, ["__typename", "streamUrl", "isRead"]),
      ...filteredAttachments,
    ];
    updatePost({
      attachments: newAttachments,
    });
  };

  onSubmitToddleDoc = async attachment => {
    if (attachment) {
      this.updatePostAttachments(attachment);
    }
  };

  onCloseToddleDoc = () => {
    this.setState({ createdToddleDoc: null });
    this.triggerDialogAction("DISCARD");
  };

  onWorkbookUpdateSuccessfully = async attachment => {
    if (attachment) {
      const newAttachment = {
        ..._.omit(attachment, [
          "streamUrl",
          "signedUrl",
          "isRead",
          "questionAttachment",
        ]),
      };
      this.addPostAttachment(newAttachment);
      this.goToStep("POST_DETAIL");
    } else {
      const {
        postDetails: { attachments },
      } = this.props;
      const sentAttachmentId = _.get(
        _.first(
          getAttachmentsByTypeFromAttachmentArr({
            attachmentsArr: attachments,
            type: "AUDIO",
            except: true,
          })
        ),
        "id",
        ""
      );
      const fetchedAttachment = await getAttachment({ id: sentAttachmentId });
      this.updatePostAttachments(fetchedAttachment);
    }
  };

  onWorkbookDiscardDirectly = () => {
    this.setWorkbookMode(null);
  };

  setPostDetailsInStore = () => {
    const { postEditDetail, mode, updatePost } = this.props;
    if (mode == "edit") {
      const { resourceItem, resourceType } = postEditDetail;
      let isResourceSkipped = false;
      if (!_.get(resourceItem, "id", "")) {
        isResourceSkipped = true;
      }

      const aiConversationId = _.get(
        _.first(_.get(postEditDetail, "aiConversation.edges", [])),
        "node.id"
      );
      // Prepare student activity data into its specific format
      const studentActivityData = getFormattedStudentActivityData(
        postEditDetail
      );

      const updatedPostEditDetail = {
        ..._.omit(postEditDetail, ["taggedPractices"]),
        taggedPractices: _.get(postEditDetail, "taggedPractices", []),
        originalibPYPElementRatings: _.get(
          postEditDetail,
          "ibPYPElementRatings",
          []
        ),
        originalIsStudentIndividuallyRated: _.get(
          postEditDetail,
          "isStudentIndividuallyRated",
          false
        ),
        courseId: _.get(postEditDetail, "course.id"),
        originalStudentActivityData: _.cloneDeep(studentActivityData),
        studentActivityData: studentActivityData,
        aiConversationId,
      };

      updatePost({
        ...updatedPostEditDetail,
        isResourceSkipped,
        resourceItem: !_.isEmpty(resourceItem)
          ? { ...resourceItem, type: resourceType }
          : null,
      });
    }
  };

  getNormalizedPostDetails = postDetails => {
    const {
      id,
      attachments = [],
      elementPYP = [],
      folders = [],
      students = {},
      resourceType = null,
      resourceItem = {},
      unitPlan = {},
      title = "",
      isPrivate = true,
      isHiddenFromStudents = true,
      taggedPractices = [],
      ibPYPElementRatings = [],
    } = postDetails || {};

    const taggedElementsValue = _.flatten(
      _.map(elementPYP, element => element.value)
    );
    const folderIds = _.map(folders, folder => folder.id);

    const studentEdges = _.get(students, "edges", []);
    const studentIds = _.map(studentEdges, student => student?.node?.id);

    const resourceId = _.get(resourceItem, "id");

    const unitPlanId = _.get(unitPlan, "id");

    const practiceIds = _.flatten(
      _.map(taggedPractices, evaluationCycleObject => {
        const { taggedPractice } = evaluationCycleObject;
        return _.map(taggedPractice, practiceObject => {
          return _.get(practiceObject, "practice.id");
        });
      })
    );

    const pypElementIds = _.map(ibPYPElementRatings, rating => rating?.id);

    return {
      id,
      attachmentContent: attachments,
      taggedElementsValue,
      folderIds,
      studentIds,
      title,
      isPrivate,
      isHiddenFromStudents,
      resourceId,
      resourceType,
      unitPlanId,
      practiceIds,
      pypElementIds,
    };
  };

  didPostDetailChange = () => {
    const {
      postDetails: postLocalObject,
      postEditDetail: postServerObject,
      mode,
      curriculumProgramType,
    } = this.props;
    //Note:In case of note creation we need to check if the note or attachment array is empty or not
    const isNote = _.get(postLocalObject, "attachments[0].type", "") === "NOTE";
    let normalizedLocalPost = this.getNormalizedPostDetails(postLocalObject);
    let normalizedServerPost = this.getNormalizedPostDetails(
      isNote && _.isUndefined(postServerObject) && isPortfolioParityEnabled()
        ? { attachments: [{ type: "NOTE", title: "" }] }
        : postServerObject
    );
    if (isDPSubjectJournalEnabled(curriculumProgramType)) {
      if (mode == "create") {
        normalizedLocalPost = _.omit(normalizedLocalPost, [
          "studentIds",
          "isHiddenFromStudents",
          "isPrivate",
        ]);
        normalizedServerPost = _.omit(normalizedServerPost, [
          "studentIds",
          "isHiddenFromStudents",
          "isPrivate",
        ]);
      }
    }
    const isChanged = !_.isEqual(normalizedLocalPost, normalizedServerPost);
    return isChanged;
  };

  onCloseClick = () => {
    const { stepList } = this.state;
    const { mode, postDetails } = this.props;

    if (_.get(stepList, "length") > 0) {
      const lastStep = _.last(stepList);
      if (
        _.includes(
          [
            "POST_DETAIL",
            "EDIT_POST",
            "MANAGE_SUBJECT_JOURNAL_POST_DETAILS",
            ..._.values(STEP_BY_ACTIVITY_TYPE),
          ],
          lastStep
        )
      ) {
        const postDetailsChanged = this.didPostDetailChange();
        const hasActivityData =
          _.size(_.get(postDetails, "studentActivityData")) > 0;
        if (postDetailsChanged || (mode == "create" && hasActivityData)) {
          if (
            isPortfolioParityEnabled() &&
            _.includes(["IN_APPROVAL", "REJECTED"], _.get(postDetails, "state"))
          ) {
            this.props.onClose("CLOSE");
            return;
          }
          this.triggerDialogAction("DISCARD");
          return;
        }
      }
    }

    if (_.get(stepList, "length") > 1) {
      this.goToPreviousStep();
    } else {
      this.props.onClose("CLOSE");
    }
  };

  onSendForApprovalClick = async () => {
    const {
      updateOrEditPost,
      updatePost,
      postDetails: { state },
      postCreateDetail,
      staffAccessPermission,
      userType,
    } = this.props;
    const courseIdFromParent = _.get(postCreateDetail, "courseId", "");

    if (
      isPortfolioReviewSetupEnabled()
        ? _.includes(staffAccessPermission, "PUBLISH")
        : true
    ) {
      updatePost({ isPrivate: false, isHiddenFromStudents: false });
    }
    try {
      updatePost({
        state: "IN_APPROVAL",
        ...(userType === "staff" && isPortfolioReviewSetupEnabled()
          ? { publishedAt: undefined }
          : {}),
      });
      this.setState({ isFullScreenLoading: true });
      await updateOrEditPost({
        isSnpV2Practices: this.isSnpV2Enabled,
        courseIdFromParent,
        staffAccessPermission,
      });
      this.props.onClose();
    } catch (e) {
      console.error(e);
      updatePost({ state: state });
    } finally {
      this.setState({ isFullScreenLoading: false });
    }
  };

  publishDraftPost = async () => {
    const { updateOrEditPost, updatePost, postCreateDetail } = this.props;

    const courseIdFromParent = _.get(postCreateDetail, "courseId", "");

    updatePost({ state: "PUBLISHED" });
    await updateOrEditPost({
      isSnpV2Practices: this.isSnpV2Enabled,
      courseIdFromParent,
      isPublishingDraftPost: true,
    });
    this.props.onClose();
  };

  onPublishClick = async () => {
    const {
      postDetails: { state },
      updateOrEditPost,
      onClose,
      userType,
      updatePost,
      postCreateDetail,
    } = this.props;
    const courseIdFromParent = _.get(postCreateDetail, "courseId", "");
    if (userType === "student") {
      updatePost({ isPrivate: false, isHiddenFromStudents: false });
    }

    try {
      if (state == "DRAFT") {
        this.setState({ isFullScreenLoading: true });
        await this.publishDraftPost();
      } else {
        this.setState({ isFullScreenLoading: true });
        await updateOrEditPost({
          isSnpV2Practices: this.isSnpV2Enabled,
          courseIdFromParent,
        });
        onClose();
      }
    } catch (e) {
      updatePost({ state: state });
    } finally {
      this.setState({ isFullScreenLoading: false });
    }
  };

  onAddAllResponsesToJournal = async () => {
    const {
      updatePost,
      updateAssignmentToJournal,
      onClose,
      studentAssignmentIds,
      postCreateDetail,
      assignmentUserMapIds,
      addBulkWorksheetResponseToPortfolio,
    } = this.props;

    try {
      const canAddWorksheetResponseToPost = _.get(
        postCreateDetail,
        "canAddWorksheetResponseToPost",
        false
      );

      updatePost({ state: "PUBLISHED" });
      this.setState({ isFullScreenLoading: true });
      if (canAddWorksheetResponseToPost) {
        // Call the new bulk mutation for worksheet responses directly from WorksheetModules
        await addBulkWorksheetResponseToPortfolio({
          assignmentUserMapIds,
        });
      } else {
        // Existing logic for non-worksheet responses
        await updateAssignmentToJournal({ studentAssignmentIds });
      }
      onClose();
    } catch (e) {
      this.setState({ isFullScreenLoading: false });
    }
  };

  triggerDialogAction = action => {
    this.setState({ currentDialogAction: action });
  };

  OnToggleDialogueClick = () => {
    this.setState({ currentDialogAction: "" });
  };

  deleteAttachment = async ({ id }) => {
    const {
      deleteAttachmentGroups,
      parentId,
      parentType,
      portalType,
    } = this.props;
    try {
      await deleteAttachmentGroups({
        attachmentGroupIds: [id],
        parentId,
        parentType,
        portalType,
      });
    } catch (e) {
      console.error(e);
    }
  };

  onDialogLeftButtonClick = () => {
    const { currentDialogAction, stepList } = this.state;
    const {
      updatePost,
      postDetails,
      resetPost,
      userType,
      userInfo,
    } = this.props;
    const lastStep = _.last(stepList);
    try {
      if (
        !_.isEmpty(
          _.get(this.state.createdToddleDoc, "attachmentGroupId", "")
        ) &&
        currentDialogAction === "DISCARD" &&
        _.get(this.state.createdToddleDoc, "type", "") === "TODDLE_DOC"
      ) {
        this.deleteAttachment({
          id: _.get(this.state.createdToddleDoc, "attachmentGroupId", ""),
        });
        this.setState({ createdToddleDoc: null });
      }

      switch (currentDialogAction) {
        case "DISCARD":
          if (
            _.includes(
              [
                "POST_DETAIL",
                "EDIT_POST",
                "MANAGE_SUBJECT_JOURNAL_POST_DETAILS",
                "MANAGE_FOOD_ACTIVITY",
                "MANAGE_NAP_ACTIVITY",
                "MANAGE_TOILET_ACTIVITY",
              ],
              lastStep
            )
          ) {
            const postDetailsClone = _.cloneDeep(postDetails);
            resetPost();
            if (userType == "student") {
              // when student selects one media type, then discard it and selects another media type,then he/she must reamain tagged.
              updatePost({
                students: {
                  edges: _.filter(
                    _.get(postDetailsClone, "students.edges", []),
                    student =>
                      _.get(student, "node.id", "") == _.get(userInfo, "id")
                  ),
                },
              });
            }
          }
          if (_.get(stepList, "length") > 1) {
            this.goToPreviousStep();
          } else {
            this.props.onClose("CLOSE");
          }
          break;
      }
    } catch (e) {
      updatePost({ state: _.get(postDetails, "state") });
    }
  };

  onDraftClick = async () => {
    const { updateOrEditPost, updatePost, postCreateDetail } = this.props;
    const courseIdFromParent = _.get(postCreateDetail, "courseId", "");

    try {
      this.setState({ isFullScreenLoading: true });
      updatePost({ state: "DRAFT", publishedAt: undefined });
      await updateOrEditPost({
        isSnpV2Practices: this.isSnpV2Enabled,
        courseIdFromParent,
      });
      this.props.onClose();
    } catch (e) {
      console.error(e);
    } finally {
      this.setState({ isFullScreenLoading: false });
    }
  };

  onMediaCreate = async () => {
    const { createMedia, parentId, parentType } = this.props;
    try {
      this.setState({ isFullScreenLoading: true });
      await createMedia({ parentId, parentType });
      this.props.onClose();
    } catch (e) {
      console.error(e);
    } finally {
      this.setState({ isFullScreenLoading: false });
    }
  };

  goToPreviousStep = () => {
    const { stepList, currentStep, stepCurrentIndexes } = this.state;

    const updatedStepList = _.initial(stepList);
    this.setState({
      currentStep: updatedStepList[updatedStepList.length - 1],
      stepList: updatedStepList,
      stepCurrentIndexes: update(stepCurrentIndexes, {
        [currentStep]: { $set: 0 },
      }),
    });
  };

  goToStep = stepName => {
    const { stepList } = this.state;
    const updatedStepList = [...stepList, stepName];
    this.setState({ currentStep: stepName, stepList: updatedStepList });
  };

  goToPage = (stepName, stepIndex) => {
    const { stepList, stepCurrentIndexes } = this.state;
    const updatedStepList = [...stepList, stepName];
    if (stepIndex >= 0 && stepIndex < _.size(STEP_DETAILS[stepName], 0))
      this.setState({
        currentStep: stepName,
        stepList: updatedStepList,
        stepCurrentIndexes: update(stepCurrentIndexes, {
          [stepName]: { $set: stepIndex },
        }),
      });
    else this.onCloseClick();
  };

  goToFinalScreen = () => {
    const { stepCurrentIndexes, currentStep } = this.state;
    this.setState({
      stepCurrentIndexes: update(stepCurrentIndexes, {
        [currentStep]: { $set: 2 },
      }),
      selectFromAllPYP: true,
    });
  };

  goToNextScreen = () => {
    const { stepCurrentIndexes, currentStep } = this.state;
    const { isInnerModal = false } = this.props;
    const currentIndex = this.getCurrentStepScreenIndex();
    const stepDetails = this.getCurrentStepDetail();
    const stepScreensLength = _.get(stepDetails, "length", 0);

    if (currentIndex >= stepScreensLength - 1) {
      if (isInnerModal == true)
        this.props?.onDoneClick && this.props?.onDoneClick();
      else this.onCloseClick();
      return;
    }

    this.setState({
      stepCurrentIndexes: update(stepCurrentIndexes, {
        [currentStep]: { $set: currentIndex + 1 },
      }),
    });
  };

  goToPreviousScreen = () => {
    const { updatePost, postDetails, onClose } = this.props;
    const { stepCurrentIndexes, currentStep, selectFromAllPYP } = this.state;
    const currentIndex = this.getCurrentStepScreenIndex();
    const {
      unitPlan,
      resourceItem,
      showTagLearningGoalsModal,
      postTaggedEntity,
    } = postDetails;
    if (currentIndex < 1) {
      // Removing this condition as we need to move to first screen in the new flow
      // if (currentStep == "TAG_FROM_ALL_LEARNING_GOALS") {
      //   this.onCloseClick();
      // }
      if (
        currentStep == "TAG_LEARNING_GOALS_FROM_ASSESSMENTS" ||
        currentStep === "TAG_LEARNING_GOALS_FROM_UNIT" ||
        currentStep === "TAG_LEARNING_GOALS_FROM_POST" ||
        currentStep == "TAG_FROM_ALL_LEARNING_GOALS"
      ) {
        updatePost({ showTagLearningGoalsModal: !isPortfolioParityEnabled() });
        this.onCloseClick();
      }
      return;
    }
    if (currentStep === "TAG_PYP_ELEMENT") {
      if (
        (!_.isNil(unitPlan) && _.isNil(resourceItem)) ||
        (getIsNewGoalTaggingEnabled() &&
          !isAssessmentTagged(postTaggedEntity) &&
          isUnitPlanTagged(postTaggedEntity))
      ) {
        this.setState({
          currentStep: "TAG_LEARNING_GOALS_FROM_UNIT",
          stepList: ["TAG_LEARNING_GOALS_FROM_UNIT"],
          stepCurrentIndexes: update(stepCurrentIndexes, {
            [currentStep]: { $set: currentIndex },
          }),
        });
      } else if (!_.isNil(unitPlan) && !_.isNil(resourceItem)) {
        this.setState({
          currentStep: "TAG_LEARNING_GOALS_FROM_ASSESSMENTS",
          stepList: ["TAG_LEARNING_GOALS_FROM_ASSESSMENTS"],
          stepCurrentIndexes: update(stepCurrentIndexes, {
            [currentStep]: { $set: currentIndex },
          }),
        });
      } else if (
        (isPortfolioParityEnabled() && !_.isNil(resourceItem)) ||
        (getIsNewGoalTaggingEnabled() && isAssessmentTagged(postTaggedEntity))
      ) {
        this.setState({
          currentStep: "TAG_LEARNING_GOALS_FROM_ASSESSMENTS",
          stepList: ["TAG_LEARNING_GOALS_FROM_ASSESSMENTS"],
          stepCurrentIndexes: update(stepCurrentIndexes, {
            [currentStep]: { $set: currentIndex },
          }),
        });
      } else if (_.get(postDetails, "selectFromAllPYP", false)) {
        onClose();
        updatePost({
          ...(!showTagLearningGoalsModal && {
            showTagLearningGoalsModal: true,
          }),
        });
      } else {
        this.setState({
          currentStep: "TAG_LEARNING_GOALS_FROM_POST",
          stepList: ["TAG_LEARNING_GOALS_FROM_POST"],
          stepCurrentIndexes: update(stepCurrentIndexes, {
            [currentStep]: { $set: currentIndex },
          }),
        });
      }

      updatePost({
        selectFromAllPYP: false,
      });
      return;
    }

    this.setState({
      stepCurrentIndexes: update(stepCurrentIndexes, {
        [currentStep]: { $set: selectFromAllPYP ? 0 : currentIndex - 1 },
      }),
      selectFromAllPYP: false,
    });
    updatePost({ selectFromAllPYP: false });
  };

  getCurrentStepScreenIndex = () => {
    const { currentStep, stepCurrentIndexes } = this.state;
    return _.get(stepCurrentIndexes, currentStep, 0);
  };

  getCurrentStepDetail = () => {
    const { currentStep } = this.state;
    return _.get(STEP_DETAILS, currentStep);
  };

  getCurrentScreenDetail = () => {
    const currentStepDetail = this.getCurrentStepDetail();
    const currentStepIndex = this.getCurrentStepScreenIndex();
    return _.get(currentStepDetail, currentStepIndex, {});
  };

  addWorkbookMediaOption = mediaOptions => {
    return [
      ..._.slice(mediaOptions, 0, 4),
      "WORKBOOK",
      ..._.slice(mediaOptions, 4, mediaOptions.length),
    ];
  };

  renderScreen = () => {
    const {
      title,
      showPreview,
      screen,
      containerStyle,
    } = this.getCurrentScreenDetail();
    const currenStepScreenIndex = this.getCurrentStepScreenIndex();
    const { workbookMode } = this.state;
    const {
      postDetails,
      updatePost,
      updateFolderArray,
      updateFolderInArrayByName,
      createAttachmentGroups,
      deleteAttachmentGroups,
      mode,
      t,
      isInnerModal,
      mediaCreationOptions,
      createPostTitle,
      totalNewSnpCycles,
      curriculumProgramId,
      audioRecordingLimit,
      allowMultipleFiles,
      postCreateDetail,
    } = this.props;

    const items = _.get(postDetails, "items", []);
    const responseData = _.find(
      items,
      item => _.get(item, "itemType", "") === "STUDENT_ASSIGNMENT"
    );
    const item = _.get(responseData, "item", BLANK_OBJECT);
    const itemContent = _.get(item, "assignment.content", BLANK_OBJECT);

    const { creationTitle, isPost } = mediaCreationOptions;

    //To show different screen title for non post medias
    const updatedTitle = !isPost
      ? creationTitle
      : mode == "create"
      ? isPortfolioParityEnabled()
        ? "new_post"
        : "create_post"
      : "edit_post";

    const props = {
      onCloseClick: this.onCloseClick,
      goToNextScreen: this.goToNextScreen,
      goToFinalScreen: this.goToFinalScreen,
      goToFirstScreen: this.goToFirstScreen,
      containerStyle: isPortfolioParityEnabledAndIsJournalRoute()
        ? { maxWidth: 900, padding: "32px 40px 0" }
        : containerStyle,
      modalHeaderTitle: title ? t(title) : title,
      screenTitle: createPostTitle
        ? createPostTitle
        : updatedTitle
        ? t(updatedTitle)
        : updatedTitle,
      showScreenTitle: true, //_.get(stepList, "length", 0) == 1, //Show only in the first step
      showBack: currenStepScreenIndex > 0,
      goToPreviousScreen: this.goToPreviousScreen,
      showPreview: showPreview,
      updatePost: updatePost,
      isInnerModal: isInnerModal,
      updateFolderArray: updateFolderArray,
      updateFolderInArrayByName: updateFolderInArrayByName,
      createAttachmentGroups: createAttachmentGroups,
      deleteAttachmentGroups: deleteAttachmentGroups,
      postDetails,
      mediaCreationOptions,
      goToStep: this.goToStep,
      goToPage: this.goToPage,
      onSendForApprovalClick: this.onSendForApprovalClick,
      onPublishClick: this.onPublishClick,
      onDraftClick: this.onDraftClick,
      onMediaCreate: this.onMediaCreate,
      onAddAllResponsesToJournal: this.onAddAllResponsesToJournal,
      mode: mode,
      isSnpV2Enabled: this.isSnpV2Enabled,
      curriculumProgramId,
      totalNewSnpCycles,
      workbookMode,
      setWorkbookMode: this.setWorkbookMode,
      setShowToddleDocModal: this.toggleToddleDocModal,
      isAddLEToJournal: _.get(postDetails, "isAddLEToJournal"),
      assessmentId:
        _.get(postDetails, "assessmentId") || _.get(itemContent, "id", ""),
      LETitle:
        _.get(postDetails, "LETitle", "") ||
        _.get(itemContent, "title.value", ""),
      assessmentType:
        _.get(postDetails, "assessmentType") ||
        _.get(itemContent, "assessmentType.value", "le"),
      selectedStudentFromFeedFilter: _.get(
        this.props,
        "selectedStudentFromFeedFilter",
        undefined
      ),
      showNewDesign: _.get(this.props, "showNewDesign", false), // To show new tagging modals design
      showNewDesignV2: _.get(this.props, "showNewDesignV2", false), // To show new tagging modals design
      postServerObject: _.get(this.props, "postEditDetail"),
      canScheduleAPost: true,
      audioRecordingLimit,
      allowMultipleFiles,
      portfolioType: _.get(this.props, "portfolioType"),
      parentType: _.get(this.props, "parentType"),
      parentId: _.get(this.props, "parentId"),
      isAddStudentAttachmentToJournal: _.get(
        postDetails,
        "isAddStudentAttachmentToJournal"
      ),
      isAddAllResponsesToJournal: _.get(
        postDetails,
        "isAddAllResponsesToJournal"
      ),
      isUserAllowedToPublishPost: _.get(
        this.props,
        "isUserAllowedToPublishPost"
      ),
      isPostCtaDisabled: _.get(this.props, "isPostCtaDisabled"),
      goToPreviousStep: this.goToPreviousStep,
      canAddWorksheetResponseToPost: _.get(
        postCreateDetail,
        "canAddWorksheetResponseToPost",
        false
      ),
      curriculumProgramIdFromProps: _.get(
        this.props,
        "curriculumProgramIdFromProps"
      ),
    };

    const { currentDialogAction, createdToddleDoc } = this.state;
    const isToddleDocAdded = !_.isEmpty(createdToddleDoc);
    return (
      <React.Fragment>
        {screen ? screen(props) : null}
        {!!currentDialogAction &&
        isPortfolioParityEnabled() &&
        currentDialogAction === "DISCARD" ? (
          <DialogueBoxV3
            modalTitle={t(
              isToddleDocAdded
                ? DIALOGS_INFO[currentDialogAction].documentDiscardTitle
                : DIALOGS_INFO[currentDialogAction].title
            )}
            showModal={true}
            onClickButton1={this.onDialogConfirmClick}
            onClickButton2={this.onDialogLeftButtonClick}
            modalBody={t(
              isToddleDocAdded
                ? DIALOGS_INFO[currentDialogAction].documentDiscardMessage
                : DIALOGS_INFO[currentDialogAction].message
            )}
            toggleDialogueBoxDisplay={this.OnToggleDialogueClick}
            button2={
              t(DIALOGS_INFO[currentDialogAction].cancelButtonText) ||
              t("common:cancel")
            }
            button1={t(DIALOGS_INFO[currentDialogAction].confirmButtonText)}
            isPromptBox={DIALOGS_INFO[currentDialogAction].isPromptBox}
            promptDetail={t(DIALOGS_INFO[currentDialogAction].promptDetail)}
            button2Props={{
              ...DIALOGS_INFO[currentDialogAction].button1CancelProps(
                isPortfolioParityEnabled()
              ),
            }}
            button1Props={{
              ...DIALOGS_INFO[currentDialogAction].button2ConfirmProps(
                isPortfolioParityEnabled()
              ),
            }}
            headerStyles={_.get(
              DIALOGS_INFO[currentDialogAction],
              "headerStyles",
              BLANK_OBJECT
            )}
          />
        ) : (
          !!currentDialogAction && (
            <DialogueBoxV2
              modalTitle={t(DIALOGS_INFO[currentDialogAction].title)}
              showModal={true}
              onClickButton2={this.onDialogConfirmClick}
              onClickButton1={this.onDialogLeftButtonClick}
              modalBody={t(DIALOGS_INFO[currentDialogAction].message)}
              toggleDialogueBoxDisplay={this.OnToggleDialogueClick}
              button1={
                t(DIALOGS_INFO[currentDialogAction].cancelButtonText) ||
                t("common:cancel")
              }
              button2={t(DIALOGS_INFO[currentDialogAction].confirmButtonText)}
              isPromptBox={DIALOGS_INFO[currentDialogAction].isPromptBox}
              promptDetail={t(DIALOGS_INFO[currentDialogAction].promptDetail)}
              button1Props={{
                ...DIALOGS_INFO[currentDialogAction].button1CancelProps,
              }}
              button2Props={{
                ...DIALOGS_INFO[currentDialogAction].button2ConfirmProps(
                  isPortfolioParityEnabled()
                ),
              }}
              headerStyles={_.get(
                DIALOGS_INFO[currentDialogAction],
                "headerStyles",
                BLANK_OBJECT
              )}
            />
          )
        )}
      </React.Fragment>
    );
  };

  onReoderImageModalClose = isDone => {
    const { isReorderEdit } = this.state;
    const { updatePost } = this.props;

    if (!isReorderEdit && isDone) {
      this.goToStep("POST_DETAIL");
    } else if (!isReorderEdit) {
      updatePost({ attachments: [] });
    }
    this.setState({ showReorderModal: false });
  };

  addNewToddleDoc = async params => {
    const { createAttachmentGroups, parentId, parentType } = this.props;
    this.setState({ isFullScreenLoading: true });
    try {
      const attachmentsResponse = await createAttachmentGroups({
        input: {
          parentId,
          parentType,
          attachments: [
            { type: "TODDLE_DOC", name: _.get(params, "name", "") },
          ],
        },
      });

      this.setState({ isFullScreenLoading: false });
      const attachment = _.get(attachmentsResponse, "[0].attachments.[0]");
      if (attachment) {
        this.setState({
          createdToddleDoc: {
            ..._.cloneDeep(attachment),
            attachmentGroupId: _.get(attachmentsResponse, "[0].id"),
          },
        });
      }
    } catch (err) {
      this.setState({ isFullScreenLoading: false });
    }
  };

  renderWorkbook = () => {
    const {
      postDetails: { attachments },
      assignmentId,
      assessmentId,
    } = this.props;
    const attachmentForWorkbook =
      _.first(
        getAttachmentsByTypeFromAttachmentArr({
          attachmentsArr: attachments,
          type: "WORKBOOK",
        })
      ) || BLANK_OBJECT;
    return (
      <Workbook
        workbookMode={WORKBOOK_MODE_TYPES["WORKBOOK_MULTIPAGE_ADD_OR_EDIT"]}
        attachment={attachmentForWorkbook}
        onUpdateSuccessfully={this.onWorkbookUpdateSuccessfully}
        onDiscardDirectly={this.onWorkbookDiscardDirectly}
        assignmentId={assignmentId}
        assessmentId={assessmentId}
        shouldShowViewInstructions={true}
      />
    );
  };

  renderToddleDocModal = () => {
    return (
      <ToddleDoc
        isAddWorkFromTeacher={true}
        isEvaluation={false}
        mode={_.isEmpty(this.state.createdToddleDoc) ? "create" : "edit"}
        onClose={this.toggleToddleDocModal}
        onBackClick={this.onDiscardToddleDoc}
        createAttachment={this.addNewToddleDoc}
        createdToddleDocAttachment={this.state.createdToddleDoc}
        onSubmit={this.onSubmitToddleDoc}
      />
    );
  };

  setWorkbookMode = mode => {
    this.setState({
      workbookMode: mode,
    });
  };

  toggleToddleDocModal = ({ isSubmitted } = { isSubmitted: false }) => {
    if (isSubmitted) {
      this.props.onClose("CLOSE");
    }
    this.setState({
      showToddleDoc: !this.state.showToddleDoc,
    });
  };

  onDiscardToddleDoc = () => {
    this.triggerDialogAction("DISCARD");
  };

  render() {
    const {
      isFullScreenLoading,
      workbookMode,
      currentStep,
      stepCurrentIndexes,
      showToddleDoc,
    } = this.state;

    const {
      isInnerModal,
      isCurrentAcademicYearSelected,
      currentCurriculumProgramType,
    } = this.props;

    const isAuthAndEvalRevampEnabled = ACLStore.can(
      ENABLE_AUTH_AND_EVAL_REVAMP
    );
    const modalContentClass = classNames({
      [classes.modalContent]: isInnerModal && !showActivityTracking(),
      [classes.tagModalContent]:
        (isInnerModal && showActivityTracking()) ||
        (isDPSubjectJournalEnabled(currentCurriculumProgramType) &&
          isPortfolioParityEnabled() &&
          isInnerModal),
      [classes.tagLearningGoalsModalContent]:
        _.get(stepCurrentIndexes, currentStep) > 0 ||
        currentStep === "TAG_FROM_ALL_LEARNING_GOALS",
      [classes.tagPracticesContainer]:
        currentStep === "TAG_PRACTICES_V2" && !isAuthAndEvalRevampEnabled,
      [classes.tagPracticesContainerForAuthAndEvalRevamp]:
        currentStep === "TAG_PRACTICES_V2" && isAuthAndEvalRevampEnabled,
      [classes.tagModalContentV2]:
        isPortfolioParityEnabled() &&
        _.includes(
          [
            "TAG_LEARNING_GOALS_FROM_UNIT",
            "TAG_LEARNING_GOALS_FROM_ASSESSMENTS",
          ],
          currentStep
        ),
      [classes.tagGoalsFromPost]:
        isPortfolioParityEnabled() &&
        _.isEqual(currentStep, "TAG_LEARNING_GOALS_FROM_POST"),
      [classes.tagModalContentKeyMargin]:
        // this.state.isKeyboardOpen &&
        isTabletByUserAgent() &&
        _.includes(["TAG_PRACTICES_V2", "TAG_STUDENT"], currentStep),
    });
    const containerClasses = classNames({
      [classes.container]: true,
      [classes.adjustedHeight]: !isCurrentAcademicYearSelected,
      [classes.fullHeight]: isCurrentAcademicYearSelected,
    });
    return (
      <UIModal
        isFullScreen={!isInnerModal}
        isOpen={true}
        modalContent={modalContentClass}
        onRequestClose={this.onCloseClick}
        tabIndexValue={0}
      >
        <div
          tabIndex={-1}
          className={containerClasses}
          id={"create-post-container"}
          ref={this.containerRef}
        >
          {/* {this.renderScreen()} */}
          {!workbookMode && this.renderScreen()}
          <div className={classes.fixedDiv} />
          {workbookMode && this.renderWorkbook()}
          {showToddleDoc && this.renderToddleDocModal()}
          {isFullScreenLoading && <FullScreenLoader />}
        </div>
      </UIModal>
    );
  }
}

export { CreatePost as CreatePostBase };

//function to create media options for journal
const createMediaOptionsForJournal = (
  courseId,
  addActivityTrackingOptions,
  isStudent,
  isLearningCourseEnabled
) => {
  const mediaOptions = [];
  const postPermissionData = getSettingValue({
    name: isStudent
      ? "GradeWisePortfolioAttachmentTypesStudent"
      : "GradeWisePortfolioAttachmentTypesEducator",
    ...(isLearningCourseEnabled
      ? { learningCourseId: courseId }
      : { courseId }),
  });
  _.forEach(_.get(postPermissionData, "data"), (key, value) => {
    const parsedKey = JSON.parse(key);
    if (_.includes(["food", "nap", "toilet"], value)) {
      parsedKey &&
        addActivityTrackingOptions &&
        mediaOptions.push(`ACTIVITY_${_.toUpper(value)}`);
    } else if (value === "audio" && parsedKey) {
      mediaOptions.push("VOICE");
    } else
      parsedKey && value !== "collage" && mediaOptions.push(_.toUpper(value));
  });
  return mediaOptions;
};

const mapActionCreators = {
  updatePost,
  resetPost,
  updateOrEditPost,
  updateFolderArray,
  updateFolderInArrayByName,
  createMedia,
  setToastMsg,
  updateAssignmentToJournal,
  editStudentAssignmentSubmission,
  updateStudentListFilters,
  getPrintFile,
  addBulkWorksheetResponseToPortfolio,
  createAttachmentGroups,
  deleteAttachmentGroups,
};

const formatMediaCreationOptionsForJournal = _.memoize(
  ({
    isJournal,
    isPermissibleCurriculum,
    addActivityTrackingOptions,
    defaultMediaOptionsForJournal,
    postTypeOptions,
  }) => {
    return {
      enableTagging: true,
      enableCaption: true,
      isPost: true,
      addButtonLabel: "",
      creationTitle: "",
      showInstructionsWithVoice: false,
      addMediaOptions: [
        ...(isJournal && isPermissibleCurriculum
          ? postTypeOptions
          : defaultMediaOptionsForJournal),
        ...(!isJournal && addActivityTrackingOptions
          ? ["ACTIVITY_NAP", "ACTIVITY_TOILET", "ACTIVITY_FOOD"]
          : []),
      ],
    };
  },
  ({
    isJournal,
    isPermissibleCurriculum,
    addActivityTrackingOptions,
    defaultMediaOptionsForJournal,
    postTypeOptions,
  }) => {
    // Create optimized cache key with essential data only
    const cacheData = {
      isJournal,
      isPermissibleCurriculum,
      addActivityTrackingOptions,
      // Only include options that actually affect the output
      optionsHash:
        isJournal && isPermissibleCurriculum
          ? postTypeOptions.join("|")
          : defaultMediaOptionsForJournal.join("|"),
    };

    return JSON.stringify(cacheData);
  }
);

const defaultMediaOptionsForJournal = [
  "PHOTO",
  "VIDEO",
  "VOICE",
  "FILE",
  "WORKBOOK",
  "NOTE",
  "LINK",
];

const mapStateToProps = (state, ownProps) => {
  const selected_class = state.teacher.selected_class;
  const academicYearId = getSelectedAcademicYearId(state);
  const courseDetails = getCourseDetailsFromCache({
    id: selected_class.selected_course,
    courseGradeFilters: { academicYearId },
  });

  const curriculum = _.get(courseDetails, "curriculumProgram", BLANK_OBJECT);
  const courseId = _.get(state, "teacher.selected_class.selected_course");
  const learningCourseId = getSelectedLearningCourseId(state);
  const isCurrentAcademicYearSelected = _.get(
    state,
    "platform.academicYearSelected.isCurrentAcademicYear",
    true
  );

  const translationFilter = getPostTranslationFilter({
    userInfo: _.get(state, "login.userInfo", BLANK_OBJECT),
    shouldTranslate: false,
    handleTranslation: hasTranslationPermission(),
  });

  const mediaCreationOptions = _.get(
    ownProps,
    "mediaCreationOptions",
    BLANK_OBJECT
  );

  // condition to check should we added activity tracking option

  const isJournal =
    hasIncludeGivenPathInCurrentRoute({ path: "/journal" }) &&
    isPortFolioManagerEnabled();

  const isStudent = _.get(state, "login.userInfo.user_type", "") === "student";
  const isStaff = _.get(state, "login.userInfo.user_type", "") === "staff";

  const currentCurriculumProgramType = _.get(
    state,
    "platform.currentCurriculumProgram.type",
    ""
  );

  const addActivityTrackingOptions =
    (currentCurriculumProgramType == CURRICULUM_TYPE_PYP ||
      currentCurriculumProgramType == CURRICULUM_TYPE_UBD) &&
    showActivityTracking() &&
    _.get(state, "login.userInfo.user_type") == "staff";

  const isPermissibleCurriculum =
    currentCurriculumProgramType == CURRICULUM_TYPE_PYP ||
    currentCurriculumProgramType == CURRICULUM_TYPE_UBD ||
    currentCurriculumProgramType == CURRICULUM_TYPE_MYP ||
    (isPortfolioParityEnabled() &&
      currentCurriculumProgramType == CURRICULUM_TYPE_DP);
  const isLearningCourseEnabled = getIsLearningCoursesEnabled(state) && isStaff;
  const postPermissionData = getSettingValue({
    name: isStudent
      ? "GradeWisePortfolioAttachmentTypesStudent"
      : "GradeWisePortfolioAttachmentTypesEducator",
    ...(isLearningCourseEnabled ? { learningCourseId } : { courseId }),
  });

  const portfolioType = _.get(postPermissionData, "type");
  const staffAccessPermission = getSettingValue({
    name: "StaffPermission:PortfolioReviewer",
    organizationId: state.login.userInfo.org_id,
    userId: state.login.userInfo.id,
    currentCurriculumProgramId: getSelectedCurriculumId(state),
  });
  const isUserAllowedToPublishPost =
    _.includes(staffAccessPermission, "PUBLISH") &&
    isPortfolioReviewSetupEnabled();
  const postPermissionCourseId = isLearningCourseEnabled
    ? learningCourseId
    : courseId;
  return {
    userInfo: state.login.userInfo,
    postDetails: state.post.postDetails,
    mode: _.isNil(ownProps.mode)
      ? ownProps.postId
        ? "edit"
        : "create"
      : ownProps.mode,
    isData: true,
    isLoading: false,
    showLoaderBar: false,
    userType: state.login.userInfo.user_type,
    curriculumProgramId:
      _.get(ownProps, "postCreateDetail.curriculumProgramId") ||
      _.get(curriculum, "id"),
    isCurrentAcademicYearSelected,
    organizationId: state.login.userInfo.org_id,
    loginActiveTab: getIsAdminByRole() ? "admin" : "teacher",
    translationFilter: translationFilter,
    curriculumProgramType: _.get(
      state,
      "platform.currentCurriculumProgram.type",
      "IB_PYP"
    ),
    mediaCreationOptions: _.isEmpty(mediaCreationOptions)
      ? formatMediaCreationOptionsForJournal({
          isJournal,
          isPermissibleCurriculum,
          courseId,
          addActivityTrackingOptions,
          isStudent,
          defaultMediaOptionsForJournal,
          postTypeOptions: createMediaOptionsForJournal(
            postPermissionCourseId,
            addActivityTrackingOptions,
            isStudent,
            isLearningCourseEnabled
          ),
        })
      : mediaCreationOptions,
    currentCurriculumProgramType,
    portfolioType,
    isUserAllowedToPublishPost,
    staffAccessPermission,
  };
};

export default compose(
  connect(mapStateToProps, mapActionCreators),
  graphql(getPostDetailQuery, {
    name: "getPostDetail",
    options: ({ postId, translationFilter }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        id: postId,
        translationFilter: translationFilter,
      },
    }),
    skip: ({ postId }) => _.isNil(postId) || _.isEmpty(postId),
    props({ getPostDetail, ownProps: { postId, isData, isLoading } }) {
      return {
        isData:
          _.isEqual(postId, _.get(getPostDetail, "node.id", false)) && isData,
        networkStatus: getPostDetail.networkStatus,
        isLoading:
          getPostDetail["networkStatus"] == 1 ||
          getPostDetail["networkStatus"] == 2 ||
          getPostDetail["networkStatus"] == 4 ||
          isLoading,
        postEditDetail: getPostDetail.node,
      };
    },
  }),
  graphql(getPlatformUserDetailsQuery, {
    name: "getPlatformUserDetails",
    skip: ({
      curriculumProgramId,
      userInfo,
      userType,
      staffAccessPermission,
    }) =>
      _.isEmpty(curriculumProgramId) ||
      _.isEmpty(userInfo.id) ||
      _.isEmpty(userType) ||
      !isPortfolioReviewSetupEnabledAndIsJournalRoute() ||
      _.includes(staffAccessPermission, "PUBLISH"),
    options: ({ userInfo, userType, curriculumProgramId }) => ({
      fetchPolicy: "cache-only",
      variables: {
        id: userInfo.id,
        type: _.upperCase(userType),
        entityRelationMapFilters: {
          curriculumProgramId: curriculumProgramId,
          relatedEntityTypes: ["STAFF"],
          relationTypes: ["POST_REVIEWER"],
        },
      },
    }),
    props({
      getPlatformUserDetails,
      ownProps: { isLoading, isData, curriculumProgramId, userInfo, userType },
    }) {
      const platformUserDetails = getPlatformUserDetailsFromCache({
        id: userInfo.id,
        type: _.upperCase(userType),
        entityRelationMapFilters: {
          curriculumProgramId: curriculumProgramId,
          relatedEntityTypes: ["STAFF"],
          relationTypes: ["POST_REVIEWER"],
        },
      });

      const entityRelationMap = _.get(
        platformUserDetails,
        "entityRelationMap",
        BLANK_OBJECT
      );
      const isPostCtaDisabled =
        _.size(_.get(entityRelationMap, "edges", [])) === 1 &&
        _.first(_.get(entityRelationMap, "edges", []))?.node?.relatedEntity
          ?.isArchived;

      return {
        isData: isData,
        isPostCtaDisabled,
        isLoading: isLoading,
      };
    },
  }),
  I18nHOC({ resource: ["journal", "common", "toastMsgs"] }),
  getEvaluationCyclesGraphql,
  withLoader
)(CreatePost);

//MediaCreationOptions to handle non post medias
CreatePost.defaultProps = {
  totalNewSnpCycles: 0,
  studentAssignmentIds: [],
  allowMultipleFiles: false,
};

CreatePost.displayName = "CreatePost";
